/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OAuthFlow } from './OAuthFlow';

/**
 * Models an authorization code OAuth flow.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OAuthFlow
 */
export abstract class AuthorizationCodeOAuthFlow extends OAuthFlow {
    constructor() {
        super();
    }
}
AuthorizationCodeOAuthFlow["__class"] = "io.apicurio.datamodels.core.models.common.AuthorizationCodeOAuthFlow";
AuthorizationCodeOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




